export default [
  {
    action: 'fas fa-tachometer-alt',
    title: 'Dashboard',
    url: '/dashboard',
  },
  {
    action: 'far fa-calendar-alt',
    title: 'Schedule',
    url: '/schedule',
  },
  {
    action: 'fas fa-user-clock',
    title: 'Shifts',
    items: [
      {
        title: 'Requested Shifts',
        url: '/shifts/requested_shifts',
      },
      // TODO CL-488 uncomment, remove unresolved
      // {
      //   title: 'Worklogs',
      //   url: '/shifts/worklogs',
      // },
      {
        title: 'Unresolved Shifts',
        url: '/shifts/unresolved_shifts',
      },
    ],
  },
  {
    action: 'fas fa-clipboard',
    title: 'Reports',
    items: [
      {
        title: 'Shifts Report',
        url: '/shifts/report',
      },
      {
        title: 'PPD Report',
        url: '/ppd-report',
      },
      {
        title: 'PBJ Report',
        url: '/pbj-report',
      },
    ],
  },
  {
    action: 'fas fa-users',
    title: 'Teams',
    url: '/teams',
  },
  {
    action: 'fas fa-user-md',
    title: 'Professionals',
    url: '/users/providers',
  },
  {
    action: 'fas fa-cogs',
    title: 'Settings',
    items: [
      {
        title: 'Notifications',
        url: '/settings/notifications',
      },
    ],
  },
  {
    action: 'fas fa-hands-helping',
    title: 'Help',
    items: [
      {
        title: 'Emergency Messages',
        url: '/help/emergency-messages',
        enabled: () => userService.shouldShowEmergencyMessagesPage(),
        hideAction: true,
      },
      {
        title: 'Help Center',
        url: import.meta.env.VITE_SHIFTKEY_HELP_LINK,
        blank: true,
        useRouter: false,
      },
      {
        title: 'Contact Us',
        url: '/help',
      },
    ],
  },
  {
    action: 'fas fa-cloud-download-alt',
    title: 'Downloads',
    url: '/downloads',
  },
  {
    action: 'account_circle',
    title: 'Account',
    items: [
      {
        title: 'Profile',
        url: '/account/profile',
      },
      {
        title: 'Terms of Service',
        url: '/tos-clients',
        blank: true,
        useRouter: false,
      },
      {
        title: 'Privacy Policy',
        url: '/privacy-policy-clients',
        blank: true,
        useRouter: false,
      },
      {
        title: 'Logout',
        url: '/auth/logout',
      },
    ],
  },
];
